const $ = jQuery.noConflict();

class SearchOverlay {
    constructor() {
        this.searchInput = $('.search-page-searchform .search-text');
        this.searchOverlay = $('.search-overlay');
    }
    init() {
        this.bindEvents();
    }
    bindEvents() {
        $(this.searchInput).keyup((e) => {
            const searchValue = $(e.currentTarget).val();
            if (searchValue === '') {
                this.searchOverlay.addClass('active');
                return;
            }
            this.searchOverlay.removeClass('active');
        });
    }
}
export default new SearchOverlay();
